// src/services/patientService.js

import axios from 'axios';

// Update the base URL to point to your PHP backend in XAMPP
const BASE_URL = 'https://horizontclinic.com/horizont-be';

// Function to add a new patient
export const addPatient = async (patientData) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.post(`${BASE_URL}/addPatient.php`, patientData, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error adding patient:', error);
        return { success: false, error: error.message };
    }
};

// Function to fetch all patients
export const getPatients = async (page = 1, perPage = 10, search = '') => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.get(`${BASE_URL}/getPatients.php`, {
            params: { page, per_page: perPage, search: search || undefined },
            headers: { Authorization: `Bearer ${token}` }
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error fetching patients:', error);
        return { success: false, error: error.message };
    }
};

// Function to fetch a patient by ID (this can be extended if needed)
export const getPatientRecords = async (patientId) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.get(`${BASE_URL}/getPatients.php?id=${patientId}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error fetching patient details:', error);
        return { success: false, error: error.message };
    }
};

// Function to update a patient
export const updatePatient = async (patientData) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.post(`${BASE_URL}/updatePatient.php`, patientData, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error updating patient:', error);
        return { success: false, error: error.message };
    }
};

// Function to delete a patient
export const deletePatient = async (patientId) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.post(`${BASE_URL}/deletePatient.php`, { id: patientId }, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Error deleting patient:', error);
        return { success: false, error: error.message };
    }
};

export const getPatientDetails = async (patientId) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.get(`${BASE_URL}/getPatientDetails.php`, {
            params: { id: patientId },
            headers: { Authorization: `Bearer ${token}` }
        });
        return { success: true, data: response.data.data };
    } catch (error) {
        console.error('Error fetching patient details:', error);
        return { success: false, error: error.message };
    }
};

// Function to fetch all visits for a patient
export const getPatientVisits = async (patientId) => {
    const token = localStorage.getItem('token');
    try {
        const response = await axios.get(`${BASE_URL}/getPatientVisits.php`, {
            params: { id: patientId },
            headers: { Authorization: `Bearer ${token}` }
        });
        return { success: true, data: response.data.data };
    } catch (error) {
        console.error('Error fetching patient visits:', error);
        return { success: false, error: error.message };
    }
};
